import {
    STEP_NAME_PAY,
    STEP_NAME_PERSONAL_INFO,
    STEP_NAME_START
} from "../../../hooks/data";

export const personalAccidentStepperData = [
    {
        key: STEP_NAME_START,
        title_en: "Start",
        title_ar: "ابدأ",
    },
    {
        key: STEP_NAME_PERSONAL_INFO,
        title_en: "Your Information",
        title_ar: "بياناتك",
    },
    {
        key: STEP_NAME_PAY,
        title_en: "Pay",
        title_ar: "المراجعة والدفع",
    },
];